import { render, staticRenderFns } from "./EmployeesListsDetailsContainer.vue?vue&type=template&id=4352413e&scoped=true&"
import script from "./EmployeesListsDetailsContainer.vue?vue&type=script&lang=js&"
export * from "./EmployeesListsDetailsContainer.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesListsDetailsContainer.vue?vue&type=style&index=0&id=4352413e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4352413e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VFlex,VForm,VLayout,VTextField})
